import { cn } from '@tripleten/cn';

export const cnButton = cn('button');
